import cake1 from "../../images/cake-1.jpg";
import cake2 from "../../images/cake-2.jpg";
import cake3 from "../../images/cake-3.jpg";
import cake4 from "../../images/cake-4.jpg";
import cake5 from "../../images/cake-6.jpg";

export const productData = [
  {
    img: cake1,
    alt: "Cake",
    name: "Supreme Cake",
    desc: "Lovely cake that brings delight",
    price: "$19.99",
    button: "Add to Cart",
  },
  {
    img: cake2,
    alt: "Cake",
    name: "Paradise Cake",
    desc: "Cake that makes you feel like you are in paradise",
    price: "$16.99",
    button: "Add to Cart",
  },
  {
    img: cake3,
    alt: "Cake",
    name: "Oh See Cake",
    desc: "Highly captivating, and delightfully tasty",
    price: "$14.99",
    button: "Add to Cart",
  },
  {
    img: cake4,
    alt: "Cake",
    name: "Wowza Cake",
    desc: "Healthy, and sweet-tasting cake",
    price: "$14.99",
    button: "Add to Cart",
  },
  {
    img: cake5,
    alt: "Cake",
    name: "Manilla Cake",
    desc: "Birthday cake with a splendid taste and delightful colors!!",
    price: "$19.99",
    button: "Add to Cart",
  },
];
